module.exports = __webpack_public_path__ + "static/media/hivTesting-OFF.90527738.svg";